'use client'

import { useChapter } from '@/context/ChapterContext'
import { useVideo } from '@/context/VideoContext'
import { Hand } from 'lucide-react'
import { useEffect, useState } from 'react'
import './userInstructionTooltip.css'

export default function UserInstructionTooltip() {
  const { currentChapterNumber } = useChapter()
  const { position, isPlaying, videoReady } = useVideo()
  const [visible, setVisible] = useState(false)
  const [exiting, setExiting] = useState(false)

  useEffect(() => {
    // currentChapterNumber is 1-based (Chapter 1 = 1, Chapter 2 = 2, etc.)
    // 0 means no chapter selected yet (initial state)
    const isFirstChapter = currentChapterNumber === 1
    const isEarly = position < 5
    const shouldShow = isFirstChapter && isEarly && isPlaying && videoReady

    if (shouldShow && !visible && !exiting) {
      // Show the tooltip
      setVisible(true)
      setExiting(false)
    } else if (!shouldShow && visible && !exiting) {
      // Start exit animation
      setExiting(true)
      // Remove from DOM after animation completes
      const timeout = setTimeout(() => {
        setVisible(false)
        setExiting(false)
      }, 500) // Match CSS animation duration
      return () => clearTimeout(timeout)
    }
  }, [currentChapterNumber, position, isPlaying, videoReady, visible, exiting])

  if (!visible) return null

  return (
    <div className="tooltip-container">
      <div className={`tooltip-card ${exiting ? 'tooltip-exit' : 'tooltip-enter'}`}>
        <div className="tooltip-icon">
          <Hand size={36} className="hand-icon" />
          <div className="drag-indicator">
            <span className="drag-arrow drag-arrow-left">‹</span>
            <span className="drag-arrow drag-arrow-right">›</span>
          </div>
        </div>
        <p className="tooltip-text">Click and drag to look around</p>
      </div>
    </div>
  )
}
